import { FC, Fragment } from "react";
import React from "react";
import { ChangeNames } from "../../clients/FirebaseClient/types";
import { useFormModel } from "../core/FormModelHelpes";
import { Switch } from "../core/Switch";
import { BoxedInputWithIconAndOptionalSwitch } from "../core/BoxedInputWithIconAndOptionalSwitch";
import { RoomCoolingIcon } from "../core/icons/Icons";
import { useStyles } from "../../useStyles";

export const IncreaseExpectedElectricRoomCoolingDeviceForm: FC = () => {
    const classes = useStyles();
    const { values, setValues, getFieldProps } =
        useFormModel<ChangeNames.INCREASE_EXPECTED_ELECTRIC_ROOM_COOLING_DEVICE>();
    return (
        <Fragment>
            <BoxedInputWithIconAndOptionalSwitch
                icon={<RoomCoolingIcon />}
                content={
                    <Fragment>
                        <p className={classes.label} style={{ marginBottom: 8 }}>
                            Gerät zur Raumkühlung
                        </p>
                    </Fragment>
                }
                useSwitch={
                    <Switch
                        checked={values.increaseExpectedElectricRoomCoolingDevice.value.yes}
                        {...getFieldProps("increaseExpectedElectricRoomCoolingDevice.value.yes")}
                        onChange={(e, checked) =>
                            setValues((values) => {
                                values.increaseExpectedElectricRoomCoolingDevice.value.yes =
                                    checked;
                                values.increaseExpectedElectricRoomCoolingDevice.value.no =
                                    !checked;
                            })
                        }
                    />
                }
                detailCondition={values.increaseExpectedElectricRoomCoolingDevice.value.yes}
                detail={
                    <p className={classes.p}>
                        Nachdem Sie diesen Antrag für Ihre Leistungserhöhung abgesendet haben,
                        erfassen Sie bitte einen weiteren Antrag über den Prozess "Verbrauchsgeräte,
                        z.B. Ladeeinrichtung, Wärmepumpe, Gerät zur Raumkühlung".
                    </p>
                }
            />
        </Fragment>
    );
};
